import { Col, Row, Spin } from 'antd'
import { connect } from 'react-redux'
import { useEffect, useState } from 'react'
import { usePagination } from 'modules/core/customHooks'
import { ProcessesTable } from './components'
import processes from 'modules/processes'

const ProcessesList = ({ fetchProcessesList, processesList: { count, values } }) => {
  const [isScreenLoading, setIsScreenLoading] = useState(true)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [tablePagination, setTablePagination] = usePagination()

  useEffect(() => {
    setIsTableLoading(true)
    fetchProcessesList({ ...tablePagination }).then(() => {
      setIsScreenLoading(false)
      setIsTableLoading(false)
    })
  }, [fetchProcessesList, tablePagination])

  const renderTable = () => (
    <ProcessesTable
      loading={isTableLoading}
      dataSource={values}
      onChange={setTablePagination}
      pagination={tablePagination}
      count={count}
    />
  )

  return (
    <Spin spinning={isScreenLoading}>
      <Row gutter={[24, 24]}>
        <Col span={24}>{renderTable()}</Col>
      </Row>
    </Spin>
  )
}

const mapStateToProps = (state) => ({
  processesList: processes.selectors.getProcessesList(state),
})

const mapDispatchToProps = {
  fetchProcessesList: processes.actions.fetchProcessesList,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessesList)
